import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchTopPicksProductsAPI() {
    const response = await fetch(`${baseURL}/api/version3/top-picks`);
    if(!response.ok) throw new error("Failed to retch top picks products data");
    return response.json()
}